import { Publication, Site } from "@libry-content/types";
import { getLibrarySystemClient } from "@libry-content/integrations";
import { slugifyString } from "@biblioteksentralen/utils";

type Props = {
  publication?: Publication;
  site?: Site;
};

export const getPublicationUrl = ({ publication, site }: Props) => {
  if (!publication) {
    console.warn("getUrlFromPublication: No publication available");
    return undefined;
  }
  const librarySystem = site?.librarySystem;
  const librarySystemClient = getLibrarySystemClient(site?.librarySystem);
  const isbn = publication?.isbn;
  const manifestationParam = publication.manifestationId && `?manifestationId="${publication.manifestationId}"`;
  const isbnParam = isbn && `?isbn="${isbn}"`;
  if (librarySystem?.searchIntegration === "prod" && publication.workId) {
    return `/samling/verk/${slugifyString(publication.title)}_${publication.workId}${manifestationParam ?? isbnParam}`;
  }

  const publicationUrl = publication?.id && librarySystemClient?.getLinkToRecord(publication.id);
  if (publicationUrl) return publicationUrl;

  console.warn("getUrlFromPublication: Could not get publication url");
  return undefined;
};
